import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { RadioButton } from 'primereact/radiobutton';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';


type UpdateScopeModalDialog = {
    visible: boolean;
    onHide: () => void;
    onSubmit: (updateAll: boolean) => void;
};

const EventUpdateScopeDialog: React.FC<UpdateScopeModalDialog> = ({
    visible,
    onHide,
    onSubmit,
}) => {
    const [updateAll, setUpdateAll] = useState(false);

    const handleSubmit = () => {
        onSubmit(updateAll);
        onHide();
    };

    const footer = (
        <div className="flex justify-end gap-2">
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={onHide} />
            <Button label="Confirmar" icon="pi pi-check" onClick={handleSubmit} />
        </div>
    );

    return (
        <Dialog
            header="¿Qué desea actualizar?"
            visible={visible}
            modal
            onHide={onHide}
            style={{ width: '30vw' }}
            footer={footer}
        >

            <div className="field-radiobutton">
                <RadioButton
                    inputId="onlyThis"
                    name="updateScope"
                    value={false}
                    onChange={(e) => setUpdateAll(e.value)}
                    checked={updateAll === false}
                />
                <label htmlFor="onlyThis">Actualizar solamente <strong>este evento</strong></label>
            </div>

            <div className="field-radiobutton mt-3">
                <RadioButton
                    inputId="allRecurrences"
                    name="updateScope"
                    value={true}
                    onChange={(e) => setUpdateAll(e.value)}
                    checked={updateAll === true}
                />
                <label htmlFor="allRecurrences">Actualizar este evento y <strong>todas sus recurrencias</strong>
                    <Tooltip target=".recurrence-info">

                        <p>Serán modificados todos los campos, excepto la fecha.</p>
                        <p>Es posible cambiar el horario de los eventos.</p>
                    </Tooltip>
                    <i className='pi pi-question-circle recurrence-info ml-2'>
                    </i>
                </label>
            </div>

        </Dialog>
    );
};

export default EventUpdateScopeDialog;